import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rnd-introduction',
  templateUrl: './rnd-introduction.component.html',
  styleUrls: ['./rnd-introduction.component.css']
})
export class RndIntroductionComponent implements OnInit {

  constructor() { }

  Products: any[] = [
    {
      index: 0,
      type: '자산관리',
      imgUrl1: 'assets/images/rnd_grp1_1.png',
      imgUrl2: 'assets/images/rnd_grp1_2.png',
      antennaType: 'Folded Dipole',
      protocol: 'UHF EPC Class-1 Gen2',
      chip: 'NXP G2XM',
      centerFrequency: '923MHz',
      readRange: 'AIR 2m(4W EIRP)',
      size: '55x10x0.1mm',
      conjugate: '22+j195.1'
    },
    {
      index: 1,
      type: '가축관리',
      imgUrl1: 'assets/images/rnd_grp2_1.png',
      imgUrl2: 'assets/images/rnd_grp2_2.png',
      antennaType: 'Folded Dipole',
      protocol: 'UHF EPC Class-1 Gen2',
      chip: 'NXP G2XM',
      centerFrequency: '923MHz',
      readRange: 'AIR 2.5m(4W EIRP)',
      size: '38x27mm',
      conjugate: '22+j195.1'
    },
    {
      index: 2,
      type: '출입통제',
      imgUrl1: 'assets/images/rnd_grp3_1.png',
      imgUrl2: 'assets/images/rnd_grp3_2.png',
      antennaType: 'Slot Dipole',
      protocol: 'UHF EPC Class-1 Gen2',
      chip: 'NXP G2XM',
      centerFrequency: '923MHz',
      readRange: 'On glass 5m(4W EIRP)',
      size: '90x40x0.48mm',
      conjugate: ''
    },
    {
      index: 3,
      type: '물류관리',
      imgUrl1: 'assets/images/rnd_grp4_1.png',
      imgUrl2: 'assets/images/rnd_grp4_2.png',
      antennaType: 'Folded Dipole',
      protocol: 'UHF EPC Class-1 Gen2',
      chip: 'ALIEN H3',
      centerFrequency: '923MHz',
      readRange: 'AIR 4m(4W EIRP)',
      size: '92x5.5x0.1mm',
      conjugate: '37.18+j142.1'
    }
  ];
  ngOnInit(): void {
  }
}
